export const data = [
  {
    id: 1,
    image: '/images/about-us/socialMediatraining.png',
    title: 'Social Media Training (Online)',
  },
  {
    id: 2,
    image: '/images/about-us/family.png',
    title: 'Avanti Way (Miami)',
  },
  {
    id: 3,
    image: '/images/about-us/inman.png',
    title: 'Inman Connect (New York)',
  },
];
